/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowSculptureWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowSculptureWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Create Sculptures Together!",
    "Sculpture Workshop Awaits!",
    "Bring Your Imagination to Life!",
  ],
  title: "Sculpture Workshop",
  description: "Organize a fun sculpture workshop.",
  longDescription:
    "Gather your friends for an engaging sculpture workshop! Choose a date, decide on materials, and plan the sculptures to create!",
  emoji: "🗿",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Sculpture Workshop",
          emoji: "🗿",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the sculpture workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on sculpture themes?",
            description: "What themes should we explore during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What themes should we consider?",
                emoji: "🎭",
                completeAction: {
                  question: "Decide on materials needed?",
                  description: "What materials should we gather for sculpting?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What materials should we bring?",
                      emoji: "🛠",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Create Beautiful Sculptures!",
    outroDescription:
      "Your sculpture workshop plans are set! Enjoy the creativity!",
  },
};
